import { render, staticRenderFns } from "./phoneEdit.vue?vue&type=template&id=20582616&scoped=true&"
import script from "./phoneEdit.vue?vue&type=script&lang=js&"
export * from "./phoneEdit.vue?vue&type=script&lang=js&"
import style0 from "./phoneEdit.vue?vue&type=style&index=0&id=20582616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20582616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20582616')) {
      api.createRecord('20582616', component.options)
    } else {
      api.reload('20582616', component.options)
    }
    module.hot.accept("./phoneEdit.vue?vue&type=template&id=20582616&scoped=true&", function () {
      api.rerender('20582616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/components/phoneEdit.vue"
export default component.exports